import { useMutation, useQuery, useQueryClient } from "react-query";
import { OrganizationKeyName } from "../../../model/Organization";
import { kitchenCategoriesHttp } from "./kitchen-categories-http";

export const kitchenCategoriesCacheKeys = {
  kitchenCategories: "kitchen-categories",
  kitchenCategory: "kitchen-category",
};

export const useGetKitchenCategories = (
  organizationKeyName: OrganizationKeyName
) => {
  return useQuery(
    [kitchenCategoriesCacheKeys.kitchenCategories],
    () => kitchenCategoriesHttp.getKitchenCategories(organizationKeyName),
    { refetchOnWindowFocus: false }
  );
};

export const useGetKitchenCategory = (
  organizationKeyName?: OrganizationKeyName,
  id?: string
) => {
  return useQuery(
    [kitchenCategoriesCacheKeys.kitchenCategory, id],
    () => kitchenCategoriesHttp.getKitchenCategory(organizationKeyName, id),
    { refetchOnWindowFocus: false, enabled: !!id }
  );
};

export const useCreateKitchenCategory = () => {
  const queryClient = useQueryClient();

  return useMutation(kitchenCategoriesHttp.createKitchenCategory, {
    onSuccess: async () => {
      queryClient.refetchQueries([
        kitchenCategoriesCacheKeys.kitchenCategories,
      ]);
    },
  });
};

export const useUpdateKitchenCategory = (id?: string) => {
  const queryClient = useQueryClient();

  return useMutation(kitchenCategoriesHttp.updateKitchenCategory, {
    onSuccess: async () => {
      queryClient.refetchQueries([
        kitchenCategoriesCacheKeys.kitchenCategories,
      ]);
      if (id) {
        queryClient.refetchQueries([
          kitchenCategoriesCacheKeys.kitchenCategory,
          id,
        ]);
      }
    },
  });
};

export const useUpdateKitchenCategorySorting = () => {
  const queryClient = useQueryClient();

  return useMutation(kitchenCategoriesHttp.updateKitchenCategoriesSorting, {
    onSuccess: async () => {
      queryClient.refetchQueries([
        kitchenCategoriesCacheKeys.kitchenCategories,
      ]);
    },
  });
};
